// extracted by mini-css-extract-plugin
export default {"card-footer":"styles_card-footer__8DiUQ"};